export const SEO_ORIGIN = "https://aramfix.nl";
export const SEO_LOCALES = ["nl", "en", "de"];
export const SEO_HREFLANG = { nl: "nl-NL", en: "en", de: "de-DE" };

export const seoCopy = {
  nl: {
    homeTitle: "Bevestigingsmaterialen wereldwijd geleverd | ARAMFIX",
    homeDescription: "Zoek industriële bevestigingsmaterialen op norm, maat en materiaal. Vergelijk actuele voorraad, verpakking en internationale levering bij ARAMFIX.",
    productsTitle: "Bevestigingsmaterialen en productgroepen | ARAMFIX",
    productsDescription: "Bekijk bouten, moeren, schroeven, ringen, ankers en andere industriële bevestigingsmaterialen per productgroep.",
    categorySuffix: "bevestigingsmaterialen",
    categoryDescription: (name) => `Bekijk ${name} van ARAMFIX. Vind uitvoeringen op norm, maat, materiaal en oppervlakte en vraag actuele voorraad en levering op.`,
    notFoundTitle: "Pagina niet gevonden | ARAMFIX",
  },
  en: {
    homeTitle: "Industrial fasteners delivered worldwide | ARAMFIX",
    homeDescription: "Search industrial fasteners by standard, size and material. Compare current stock, packaging and international delivery at ARAMFIX.",
    productsTitle: "Fasteners and product groups | ARAMFIX",
    productsDescription: "Browse bolts, nuts, screws, washers, anchors and other industrial fasteners by product group.",
    categorySuffix: "fasteners",
    categoryDescription: (name) => `Browse ${name} from ARAMFIX. Find variants by standard, size, material and surface and request current stock and delivery.`,
    notFoundTitle: "Page not found | ARAMFIX",
  },
  de: {
    homeTitle: "Industriebefestiger weltweit geliefert | ARAMFIX",
    homeDescription: "Finden Sie industrielle Befestiger nach Norm, Abmessung und Material. Vergleichen Sie Bestand, Verpackung und internationale Lieferung.",
    productsTitle: "Befestiger und Produktgruppen | ARAMFIX",
    productsDescription: "Entdecken Sie Schrauben, Muttern, Scheiben, Anker und weitere industrielle Befestiger nach Produktgruppe.",
    categorySuffix: "Befestigungselemente",
    categoryDescription: (name) => `Entdecken Sie ${name} von ARAMFIX. Finden Sie Ausführungen nach Norm, Abmessung, Material und Oberfläche sowie aktuelle Lieferoptionen.`,
    notFoundTitle: "Seite nicht gefunden | ARAMFIX",
  },
};

export const currentSeoLocale = (fallback = "en") => {
  const first = typeof window === "undefined" ? "" : window.location.pathname.split("/")[1];
  return SEO_LOCALES.includes(first) ? first : (SEO_LOCALES.includes(fallback) ? fallback : "en");
};

export const isSeoTargetRoute = () => {
  if (typeof window === "undefined") return true;
  const first = window.location.pathname.split("/")[1];
  if (!/^[a-z]{2}$/i.test(first)) return true;
  return SEO_LOCALES.includes(first.toLowerCase());
};

export const localizedSeoUrl = (internalPath, locale) => `${SEO_ORIGIN}/${locale}${internalPath === "/" ? "/" : internalPath}`;
export const currentCanonicalUrl = () => `${SEO_ORIGIN}${window.location.pathname}`;

export const truncateSeoText = (value, maximum) => {
  const normalized = String(value || "").replace(/\s+/g, " ").trim();
  if (normalized.length <= maximum) return normalized;
  const clipped = normalized.slice(0, maximum - 1);
  const boundary = clipped.lastIndexOf(" ");
  return `${clipped.slice(0, boundary > maximum * 0.65 ? boundary : clipped.length).replace(/[,:;\-]+$/, "")}…`;
};

const setMeta = (selector, key, value) => {
  let node = document.head.querySelector(selector);
  if (!node) {
    node = document.createElement("meta");
    const match = selector.match(/meta\[(name|property)="([^"]+)"\]/);
    if (match) node.setAttribute(match[1], match[2]);
    document.head.appendChild(node);
  }
  node.setAttribute(key, value);
};

export function applyPageMetadata({ title, description, internalPath, locale, indexable = true, type = "website", image }) {
  const canonical = currentCanonicalUrl();
  document.title = truncateSeoText(title, 65);
  setMeta('meta[name="description"]', "content", truncateSeoText(description, 160));
  setMeta('meta[name="robots"]', "content", indexable ? "index,follow,max-image-preview:large" : "noindex,follow");
  setMeta('meta[property="og:title"]', "content", document.title);
  setMeta('meta[property="og:description"]', "content", truncateSeoText(description, 160));
  setMeta('meta[property="og:url"]', "content", canonical);
  setMeta('meta[property="og:type"]', "content", type);
  if (image) setMeta('meta[property="og:image"]', "content", new URL(image, SEO_ORIGIN).href);
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
  link.href = canonical;
  document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((node) => node.remove());
  if (indexable && internalPath && SEO_LOCALES.includes(locale)) {
    SEO_LOCALES.forEach((code) => {
      const alternate = document.createElement("link");
      alternate.rel = "alternate";
      alternate.hreflang = SEO_HREFLANG[code];
      alternate.href = localizedSeoUrl(internalPath, code);
      document.head.appendChild(alternate);
    });
    const fallback = document.createElement("link");
    fallback.rel = "alternate";
    fallback.hreflang = "x-default";
    fallback.href = localizedSeoUrl(internalPath, "nl");
    document.head.appendChild(fallback);
  }
}

export function markPrerenderReady() {
  if (typeof window !== "undefined") window.__ARAMFIX_MARK_APP_READY__?.();
}